import { Card, Row } from 'components'
import { useGetQuery } from 'hooks'
import { useParams } from 'react-router-dom'
import { Panel } from '../components'

export const HostDashShow = () => {
  const { slug } = useParams()

  const { data } = useGetQuery({
    url: `/host/queue/${slug}`
  })

  const panelAt = (slot) =>
    data?.queue?.QueueItems?.find((i) => i?.details?.slot === slot)

  return (
    <>
      <Row>
        {[0, 1, 2].map((slot) => (
          <Card className="tile" key={slot}>
            <Panel panel={panelAt(slot)} />
          </Card>
        ))}
      </Row>
      <Row>
        {[3, 4].map((slot) => (
          <Card className="tile" key={slot}>
            <Panel panel={panelAt(slot)} />
          </Card>
        ))}
      </Row>
    </>
  )
}
